export const weekDayName = id => {
	switch (id) {
		case '0':
			return 'Du'
		case '1':
			return 'Se'
		case '2':
			return 'CH'
		case '3':
			return 'Pa'
		case '4':
			return 'Ju'
		case '5':
			return 'SH'
		case '6':
			return 'Ya'

		default:
			return ''
	}
}
